// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: 'c66ae750712a8c720da28029e8facc3e59e58d02',
  short: 'c66ae75',
  builtAt: '2026-10-26T19:41:06.118Z',
} as const;
